const BOMStepHeader = ({ step }: { step: number }) => {
  return (
    <div className="text-sm text-gray-500 font-medium flex gap-1">
      <span className={step === 1 ? "text-blue-600 font-semibold" : ""}>BOM List</span>
      {step >= 2 && (
        <>
          <span>/</span>
          <span className={step === 2 ? "text-blue-600 font-semibold" : ""}>General Details</span>
        </>
      )}
      {step >= 3 && (
        <>
          <span>/</span>
          <span className={step === 3 ? "text-blue-600 font-semibold" : ""}>Map Clinics & Setup Price</span>
        </>
      )}
    </div>
  );
};

export default BOMStepHeader;
